var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"https://gabrielwenfu.github.io/cfs-color/","target":"_blank"}},[_c('svg',{staticClass:"icon",staticStyle:{"width":"50px","height":"50px"}},[_c('use',{attrs:{"xlink:href":"static/icon.svg#github"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c81e1278","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = null
// module chunks = 